import React from 'react'
import './TeamAppointment.css'
import {
  Input,
  Upload,
  Icon,
  Button,
  Form,
  DatePicker,
  Row,
  Col,
  Select,
  TimePicker,
  message,
  Modal
} from 'antd'
import moment from 'moment'
import request from '@/utils/request'
import axios from 'axios'
import { setKey, getKey } from '@/utils/Cookie'
import ReactDOM from 'react-dom'

const FormItem = Form.Item
const { RangePicker } = DatePicker
const { Option } = Select

var myCaptcha = null
class TeamAppointmentForm extends React.Component {
  state = {
    IndexKey: null, //当前天数索引值
    currentIndex: null, //选择样式
    visible: true, //显示新增预约
    tid: null, //选择日期
    TimeArray: [], //时间
    TimeArrayData: [], //时间票数
    OrderList: [], //我的订单数据
    optionData: null,
    dataObjContent:null
  }
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
    var that = this
    // eslint-disable-next-line
    myCaptcha = _dx.Captcha(document.getElementById('c1'), {
      style: 'popup',
      appId: 'ebaf330bfcdb7ac9b10a42b9a8e4a474', //appId，在控制台中“应用管理”或“应用配置”模块获取
      success: function(token) {
        // console.log('token:', token)
        myCaptcha.hide()
        myCaptcha.reload()
        request
          .get(`/v1/mobile/messages/slide/code?token=${token}`)
          .then(res => {
            // console.log('res1111')
            // console.log(res)
            if (res == true) {
              request
                .post('/v1/group/reserve/mobile', that.state.optionData)
                .then(res => {
                  // console.log('res')
                  // console.log(res)

                  if (res == '提交成功') {
                    setKey('teamSuccess', 2)
                    that.props.history.push('/Main/Home/ShowAppointment')
                  } else {
                    setKey('MessageFiald', JSON.stringify(res))
                    that.props.history.push('/Main/Home/ShowAppointmentFaild')
                  }
                })
            }
          })
      },
      fail: function(msg) {
        // console.log('token:', msg)
      }
    })
  }
  componentWillMount() {
    this.getDates()
  }
  sendData() {
    const values = {
      ageGroup: '3',
      carNumber: '31',
      consumeTime: '01:00:00',
      curator: '100',
      exitTime: '19:00:00',
      groupType: '3',
      isRepast: '2',
      leaderMobile: '13882198375',
      member: '200',
      tid: '20'
    }
    request.post('/v1/group/reserve/mobile', values).then(res => {
      // console.log('res')
      // console.log(res)
    })
  }
  //获得当前时间票数
  getTime() {
    request
      .get('/v1/mobile/ticket/info?type=1', {
        withCredentials: true
      })
      .then(res => {
        // console.log('res')
        // console.log(res)
        // console.log(this.state.TimeArray)
        const ArrayData = res
        for (var i = 0; i < this.state.IndexKey; i++) {
          ArrayData.unshift({})
        }
        // console.log(ArrayData)
        this.setState({
          TimeArrayData: ArrayData
        })
      })
  }
  //时间数据改变
  ChangeTime(date) {
    const year = date.split('/')[0]
    const month = date.split('/')[1]
    const day = date.split('/')[2]
    const monthText = Number(month) < 10 ? `0${month}` : month
    const dayText = Number(day) < 10 ? `0${day}` : day
    return `${year}-${monthText}-${dayText}`
  }
  /* 获得当前时间所在的周日期*/
  getDates() {
    var that = this
    var curDate = new Date()
    var ThisTime = new Date(curDate.setDate(curDate.getDate() + 0))
    var timesStamp = ThisTime.getTime()
    var currenDay = ThisTime.getDay()
    var dates = []
    var days = []

    for (var i = 0; i < 7; i++) {
      dates.push(
        that.ChangeTime(
          new Date(
            timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
          )
            .toLocaleDateString()
            .replace(/[年月]/g, '/')
            .replace(/[日上下午]/g, '/')
        )
      )
    }
    for (var i = 0; i < 8; i++) {
      days.push(
        that.ChangeTime(
          new Date(timesStamp + 24 * 60 * 60 * 1000 * i)
            .toLocaleDateString()
            .replace(/[年月]/g, '/')
            .replace(/[日上下午]/g, '/')
        )
      )
    }

    var lastTime = new Date(curDate.setDate(curDate.getDate() + 14))
    // console.log(dates)
    // console.log(days)

    var arr = dates.concat(days) //合并数组
    var arrNew = Array.from(new Set(arr)) //通过set集合去重
    // console.log(arrNew)
    this.setState({
      IndexKey: dates.indexOf(days[0]),
      TimeArray: arrNew
    })
    this.getTime()
    this.getDataInfo()
  }
  //选择样式
  setActive(data, index) {
    // console.log(data)
    // console.log(index)
    this.setState({
      currentIndex: index,
      tid: data.id
    })
  }
  GetPerson() {
    this.props.history.push('/Main/Home/ShowAppointment')
    // this.props.history.push('/Main/Home/ShowAppointmentFaild')
  }
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values)
        var objTid = {}
        if (this.state.tid) {
          objTid.tid = this.state.tid
        } else {
          message.error('请选择参观日期！')
          return
        }
        const objData = {}
        Object.assign(objData, values, objTid)
        this.setState({
          optionData: objData
        })
        myCaptcha.show()
        // request.post('/v1/group/reserve/mobile', objData).then(res => {
        //   console.log('res')
        //   console.log(res)
        //   if (res == '提交成功') {
        //     this.props.history.push('/Main/Home/ShowAppointment')
        //   } else {
        //     setKey('MessageFiald', JSON.stringify(res))
        //     this.props.history.push('/Main/Home/ShowAppointmentFaild')
        //   }
        // })
      }
    })
  }

  handleSelectChangeEat = value => {
    // console.log(value)
  }
  handleSelectChangeGroupType = value => {
    // console.log(value)
    // console.log(this.props.form.getFieldValue('groupType'))
  }
  handleSelectChangeAgeGroup = value => {
    // console.log(value)
    // console.log(this.props.form.getFieldValue('groupType'))
  }
  //选择开始时间
  onChangeStart = (time, timeString) => {
    this.props.form.setFieldsValue({
      consumeTime: timeString
    })
  }
  //选择结束时间
  onChangeEnd = (time, timeString) => {
    this.props.form.setFieldsValue({
      exitTime: timeString
    })
  }
  //显示时间配置
  ShowDate(date) {
    const year = date.split('-')[0]
    const month = date.split('-')[1]
    const day = date.split('-')[2]
    return `${month}月${day}日`
  }
  // 隐私等须知
  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=3')
    .then(res => {
       console.log('res')
      // console.log(res)
      // console.log(this.state.TimeArray)
      const data = res
      // for (var i = 0; i < this.state.IndexKey; i++) {
      //   ArrayData.unshift({})
      // }
      // console.log(ArrayData)
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }
  render() {
    const { getFieldDecorator, setFieldValue } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    const formItemLayoutItem = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 16,
          offset: 8
        }
      }
    }
    const { IndexKey, TimeArrayData, currentIndex,dataObjContent } = this.state
    return (
      <div className="TeamAppointment">
        <div className="TeamAppointment_title">
          <span className="TeamAppointment_title_line"></span>
          <span className="TeamAppointment_title_text">选择时间</span>
        </div>
        <div className="TeamAppointment_time">
          <div className="TeamAppointment_time_header">
            <div className="item">星期一</div>
            <div className="item">星期二</div>
            <div className="item">星期三</div>
            <div className="item">星期四</div>
            <div className="item">星期五</div>
            <div className="item">星期六</div>
            <div className="item">星期日</div>
          </div>
          <div className="TeamAppointment_time_conten">
            {TimeArrayData.map((item, index) => {
              return (
                <div className="item" key={index}>
                  {IndexKey > index ? (
                    <div className="itemBox"></div>
                  ) : item.isOpen && item.isOpen == 1 ? (
                    item.remnantNum && item.remnantNum > 0 ? (
                      <div
                        onClick={el => this.setActive(item, index)}
                        className={`itemBox  ${
                          index === currentIndex ? 'itemActive' : null
                        }`}
                      >
                        <div className="num">{this.ShowDate(item.time)}</div>
                        <div className="time">可预约</div>
                      </div>
                    ) : (
                      <div className="itemBox itemAll">
                        <div className="num">{this.ShowDate(item.time)}</div>
                        <div className="numAll">约满</div>
                      </div>
                    )
                  ) : (
                    <div className="itemBox itemAll">
                      <div className="num">{this.ShowDate(item.time)}</div>
                      <div className="numAll">闭馆</div>
                    </div>
                  )}

                  {/* item.remnantNum && item.remnantNum > 0 ? (
                    <div
                      onClick={el => this.setActive(item, index)}
                      className={`itemBox  ${
                        index === currentIndex ? 'itemActive' : null
                      }`}
                    >
                      <div className="num">{this.ShowDate(item.time)}</div>
                      <div className="time">余{item.remnantNum}票</div>
                    </div>
                  ) : (
                    <div className="itemBox itemAll">
                      <div className="num">{this.ShowDate(item.time)}</div>
                      <div className="numAll">约满</div>
                    </div>
                  ) */}
                </div>
              )
            })}
          </div>
        </div>
        <div className="TeamAppointment_title">
          <span className="TeamAppointment_title_line"></span>
          <span className="TeamAppointment_title_text">填写预约团队资料</span>
        </div>
        <div className="TeamAppointment_AddConten">
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
            <Row>
              <Col span={14}>
                <Form.Item label="预约时间" {...formItemLayoutItem}>
                  {getFieldDecorator('consumeTime', {
                    rules: [{ required: true, message: '请选择入馆时间' }]
                  })(
                    <div style={{float:"left"}}>
                      <TimePicker
                        onChange={this.onChangeStart}
                        defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
                      />
                      <span style={{ marginLeft: '20px' }}>-</span>
                    </div>
                  )}
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item {...formItemLayoutItem}>
                  {getFieldDecorator('exitTime', {
                    rules: [{ required: true, message: '请选择出馆时间' }]
                  })(
                    <div>
                      <TimePicker
                        onChange={this.onChangeEnd}
                        defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
                      />
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item label="团队类型">
              {getFieldDecorator('groupType', {
                rules: [{ required: true, message: '请选择团队类型' }]
              })(
                <Select
                  placeholder="请选择团队类型"
                  onChange={this.handleSelectChangeGroupType}
                >
                  <Option value="1">幼儿园</Option>
                  <Option value="2">小学</Option>
                  <Option value="3">中学</Option>
                  <Option value="4">大学</Option>
                  <Option value="5">教育机构</Option>
                  <Option value="6">企事业单位</Option>
                </Select>
              )}
            </Form.Item>
            <Form.Item label="团队年龄段">
              {getFieldDecorator('ageGroup', {
                rules: [{ required: true, message: '请选择团队年龄段' }]
              })(
                <Select
                  placeholder="请选择团队年龄段"
                  onChange={this.handleSelectChangeAgeGroup}
                >
                  <Option value="1">2年级以下（含2年级）</Option>
                  <Option value="2">3-6年级（含6年级）</Option>
                  <Option value="3">7年级以上（含7年级）</Option>
                </Select>
              )}
            </Form.Item>
            <Row>
              <Col span={14}>
                <Form.Item label="成年人数：" {...formItemLayoutItem}>
                  {getFieldDecorator('curator', {
                    rules: [{ required: true, message: '请输入成年人数' }]
                  })(<Input placeholder="请输入成年人数" />)}
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="未成年人数：" {...formItemLayoutItem}>
                  {getFieldDecorator('member', {
                    rules: [{ required: true, message: '请输入未成年人数' }]
                  })(<Input placeholder="请输入未成年人数" />)}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="联系人电话：">
              {getFieldDecorator('leaderMobile', {
                rules: [{ required: true, message: '请输入联系人电话' }]
              })(<Input placeholder="请输入联系人电话" />)}
            </Form.Item>
            <Row>
              <Col span={14}>
                <Form.Item label="车辆信息：" {...formItemLayoutItem}>
                  {getFieldDecorator('carNumber', {
                    rules: [{ required: true, message: '请输入车辆信息' }]
                  })(<Input placeholder="请输入车辆信息" />)}
                </Form.Item>
              </Col>
              <Col span={10}>
                <div style={{ 'text-align': 'left', 'padding-left': '15px' }}>
                  <span style={{ marginTop: '8px', display: 'inline-block' }}>
                    仅限12座以上大客车
                  </span>
                </div>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="是否就餐">
                  {getFieldDecorator('isRepast', {
                    rules: [{ required: true, message: '请选择是否就餐' }]
                  })(
                    <Select
                      placeholder="是否就餐"
                      onChange={this.handleSelectChangeEat}
                    >
                      <Option value="2">是</Option>
                      <Option value="1">否</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item {...tailFormItemLayout}>
              {/* <Button type="primary" htmlType="submit">
                立即预约
              </Button> */}
              <div className="TeamAppointment_footer">
                <Button
                  className="TeamAppointment_footer_button"
                  // onClick={el => this.GetPerson()}
                  htmlType="submit"
                >
                  立即预约
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
        <div className="ccc">
          <div id="c1" ref="myInput"></div>
        </div>
        <div className="instructions_title">
          <span className="instructions_title_line"></span>
          <span className="instructions_title_text">团队预约须知</span>
        </div>
        <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
          </div>
      </div>
    )
  }
}
const TeamAppointment = Form.create()(TeamAppointmentForm)
export default TeamAppointment
